/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { BakendHttpResponse } from '../../bakend-http-response';
import { RequestBuilder } from '../../request-builder';

import { BackendGrafanaPanelLinkResponseDto } from '../../models/backend-grafana-panel-link-response-dto';

export interface GetPanelLinkGrafanaPanelsPanelKeyGet$Params {
  panel_key: string;

  /**
   * ID проекта (для проектных панелей)
   */
  project_id?: number | null;
  time_from?: string;
  time_to?: string;
}

export function getPanelLinkGrafanaPanelsPanelKeyGet(
  http: HttpClient,
  rootUrl: string,
  params: GetPanelLinkGrafanaPanelsPanelKeyGet$Params,
  context?: HttpContext,
): Observable<BakendHttpResponse<BackendGrafanaPanelLinkResponseDto>> {
  const rb = new RequestBuilder(rootUrl, getPanelLinkGrafanaPanelsPanelKeyGet.PATH, 'get');
  if (params) {
    rb.path('panel_key', params.panel_key, {});
    rb.query('project_id', params.project_id, {});
    rb.query('time_from', params.time_from, {});
    rb.query('time_to', params.time_to, {});
  }

  return http.request(rb.build({ responseType: 'json', accept: 'application/json', context })).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as BakendHttpResponse<BackendGrafanaPanelLinkResponseDto>;
    }),
  );
}

getPanelLinkGrafanaPanelsPanelKeyGet.PATH = '/grafana/panels/{panel_key}';
